import Config from '../config';
import Utils from '../utils/util';
import {
    isShelf,
    isFreezer,
    isInStage,
    isPartition,
    isGoods,
    isBafflePlate,
    isTextarea,
    isEmptyShelf,
    isLayer,
    isBeam,
    isDishrack
} from './cubeInfo';

function getKeyPathAlias(cubeId: CubeId, keyPath: string): string {
    if (isGoods(cubeId)) {
        return goodsKeyAlias(keyPath);
    }

    if (isPartition(cubeId)) {
        return layerKeyAlias(keyPath);
    }

    if (isShelf(cubeId)) {
        return shelfKeyAlias(keyPath);
    }

    return '';
}

function goodsKeyAlias(keyPath: string): string {
    // 先取隐射关系
    let baseKeyMap: GoodsKeyMap = Config.get({
        moduleName: 'goods',
        key: 'keyMap'
    });
    let goodsKeyMap: GetFromGoodsKeyMap = Config.get({
        moduleName: 'goods',
        key: 'getFromGoodsKeyMap'
    });

    if (Utils.hasValue(baseKeyMap, keyPath)) {
        return Utils.getTargetValueKeyName(baseKeyMap, keyPath);
    }

    if (Utils.hasValue(goodsKeyMap, keyPath)) {
        return Utils.getTargetValueKeyName(goodsKeyMap, keyPath);
    }

    return '';
}

function layerKeyAlias(keyPath: string): string {
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });

    if (Utils.hasValue(layerKeyMap, keyPath)) {
        return Utils.getTargetValueKeyName(layerKeyMap, keyPath);
    }

    return '';
}

function shelfKeyAlias(keyPath: string): string {
    let shelfKeyMap: ShelfKeyMap = Config.get({
        moduleName: 'shelf',
        key: 'keyMap'
    });

    if (Utils.hasValue(shelfKeyMap, keyPath)) {
        return Utils.getTargetValueKeyName(shelfKeyMap, keyPath);
    }

    return '';
}

export {
    getKeyPathAlias
};
